import React from "react";
import PropTypes from "prop-types";

// eslint-disable-next-line import/no-cycle
import PaymentPageContainer from "../../Containers/PaymentPageContainer";

const PaymentPageContent = ({ containers = [] }) => (
    <PaymentPageContainer containers={containers} />
);

PaymentPageContent.propTypes = {
    containers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default PaymentPageContent;
